/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Fade, Grid, Typography } from '@mui/material';
import React from 'react';
import styled from 'styled-components';
import { useCookies } from '../../providers/CookiesProvider';

const WarningContent = styled.section`
  position: fixed;
  bottom: 0.5rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;

  background-color: var(--white);
  padding: 1rem;
  width: 100%;
  max-width: 1200px;
  border-radius: 0.5rem;
  box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.5);

  .btnCookies {
    border: none;
    background-color: var(--cta);
    text-transform: lowercase;

    &:hover {
      border: none;
      background-color: var(--cta-dark);
    }
  }
`;

export const CookiesWarning = () => {
  const { cookiesAllowed, setCookiesAllowed } = useCookies();

  const acceptCookiesPolicity = () => {
    localStorage.setItem(process.env.REACT_APP_ACCEPT_COOKIES, true);
    setCookiesAllowed(true);
  }
  
  return (
    <>
      {!cookiesAllowed && (
        <Fade in={ !cookiesAllowed }>
          <WarningContent>
            <Grid container spacing={2} alignItems='center'>
              <Grid item sm={9} xs={12}>
                <Typography variant='body2' className='middle--text'>
                  Nós utilizamos cookies para personalizar anúncios e melhorar a sua experiência no site. Ao continuar navegando, você concorda com a nossa <a href='/politica-de-privacidade' className='dark--text bold-text'>Política de Privacidade</a>.
                </Typography>
              </Grid>
              <Grid item sm={3} xs={12} align='right'>
                <Button
                  variant='contained'
                  disabled={cookiesAllowed === null}
                  onClick={ acceptCookiesPolicity }
                  className='btnCookies'
                >
                  continuar e fechar
                </Button>
              </Grid>
            </Grid>
          </WarningContent>
        </Fade>
      )}
    </>
  )
}
